import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const BULK_MODIFIERS_CONFIG = {
  BULK_MODIFIERS: (queryParams) => ({
    endPoint: `bulk-point-modifier/list?${buildQueryParams(queryParams)}`,
    // mockData: BulkModifiersList,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  }),
  REVIEW_BULK_MODIFIERS: {
    endPoint: 'bulk-point-modifier',
    method: HTTP_METHODS.POST
  },
  VALIDATE_BULK_MODIFIER_NAME: {
    endPoint: 'bulk-point-modifiers/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  BULK_MODIFIERS_CSV_DOWNLOAD: (queryParams) => {
    const query = queryParams ? `?${buildQueryParams(queryParams)}` : '';
    return {
      endPoint: `bulk-point-modifier/download${query}`,
      method: HTTP_METHODS.POST
    };
  },
  BULK_MODIFIER_DETAIL: (id, page, pageSize, type) => {
    const VALID_TYPES = ['id', 'groupId', 'uuid'];
    const safeType = VALID_TYPES.includes(type) ? type : 'id';
    const params = {[safeType]: id, page, pageSize};
    return {
      endPoint: `bulk-point-modifier/list?${buildQueryParams(params)}`,
      method: HTTP_METHODS.POST
    };
  },
  BULK_MODIFIERS_DRAFT: {
    endPoint: 'bulk-point-modifiers/draft',
    method: HTTP_METHODS.POST
  },
  BULK_MODIFIERS_DRAFT_UPDATE: {
    endPoint: 'bulk-point-modifiers/draft',
    method: HTTP_METHODS.PUT
  }
};
